<template>
  <v-toolbar
    flat
    dark
    max-height="56"
    color="secondary"
  >
    <h-search-btn v-model="searching" />
    <v-text-field
      v-if="searching"
      v-model="needle"
      autofocus
      hide-details
      class="mx-3"
      @input="$emit('search')"
    />
    <template v-else>
      <h-dish-order v-if="!! config('shouldOrderDishes')" />
      <v-spacer />
      <v-toolbar-title v-text="title" />
      <v-spacer />
    </template>
    <v-btn
      depressed
      color="primary"
      :disabled="processing"
      @click.stop.prevent="done()"
      v-text="__('done')"
    />
    <h-catalog-tour v-model="showCatalogTour" />
    <h-order-tour v-model="showOrderTour" />
  </v-toolbar>
</template>

<script>
  import { mapState, mapGetters } from 'vuex'
  import ActivatesClickBlocker from '@/Mixins/ActivatesClickBlocker'
  import I18n from '@/Mixins/I18n'
  import ShowsTour from '@/Mixins/ShowsTour'
  import HCatalogTour from '@/Components/Tour/Catalog'
  import HOrderTour from '@/Components/Tour/Order'
  import HSearchBtn from './SearchBtn'
  import HDishOrder from './DishOrder'

  export default {
    mixins: [
      ActivatesClickBlocker,
      I18n,
      ShowsTour,
    ],

    components: {
      HCatalogTour,
      HOrderTour,
      HSearchBtn,
      HDishOrder,
    },

    props: {
      value: {
        required: true,
        type: Boolean,
      },
      title: {
        required: true,
        type: String,
      },
    },

    data: () => ({
      showCatalogTour: false,
      showOrderTour: false,
      processing: false,
      isClosing: false,
    }),

    computed: {
      hasContents () {
        return !! this.$store.state.orders.current.orderContents.length
      },
      dialogLocked () {
        return this.$store.state.orders.dialogs.locked
      },
      ...mapGetters('orders', [
        'config',
      ]),
      needle: {
        get () {
          return this.$store.state.catalog.needle
        },
        set (v) {
          this.$store.commit('catalog/needle', v)
        },
      },
      searching: {
        get () {
          return this.value
        },
        set (v) {
          this.$emit('input', v)
        },
      },
    },

    watch: {
      // Reset processing flag when catalog opens, with delay to ensure close/save cycle completes
      '$store.state.orders.dialogs.dialog' (newDialog) {
        if (newDialog === 'catalog' && this.processing) {
          // Catalog is opening - reset after delay to prevent rapid Done/+/Done clicks
          setTimeout(() => {
            this.processing = false
            this.isClosing = false
          }, 50)
        }
      },
    },

    mounted () {
      if (this.shouldViewTour()) {
        setTimeout(() => this.openCatalogTour(), 400)
      }
    },

    methods: {
      done () {
        // Prevent double-click by immediately disabling the button
        if (this.processing) {
          return
        }
        // Set processing flag immediately to disable button
        this.processing = true
        
        // Use nextTick to ensure DOM updates before continuing
        this.$nextTick(() => {
          if (! this.shouldViewTour()) {
            this.close()
            return
          }
          this.hasContents ? this.openOrderTour() : this.openCatalogTour()
        })
      },
      close () {
        if (this.isClosing) {
          return
        }
        this.isClosing = true
        
        this.activateClickBlocker(() => {
          this.$store.dispatch('orders/dialogs/close')
        })
      },
      openCatalogTour () {
        this.showCatalogTour = true
      },
      openOrderTour () {
        this.close()
        setTimeout(() => this.showOrderTour = true, 175)
      },
    },
  }
</script>
